export const documentsEn = {
  //BEGIN Michael
  DOCUMENT: 'Document',
  DOCUMENTS: 'Documents',
  DOCUMENT_TYPE: 'Document Type',
  OTHER: 'Other',
  EXPIRATION_DATE: 'Expiration Date',
  INFO_ALL_DOCS_SAME:
    'All the files will be uploaded with the same document type and expiration date.',
  OTHER_FUNCTION_LINKED: 'This document type is linked to other functions.',
  NOA_WARNING:
    'A client can only have one NOA active at any given time. If you upload a new NOA document, the previous documents will be deactivated. If you upload more than one document with the NOA Type, only the last document will be kept active.',
  ONLY_PDF: 'Only PDF files are allowed.',
  DOCUMENT_TYPE_NOT_ALLOWED: 'File type not allowed. Allowed types: PDF, images and Excel.',
  ARCHIVED: 'Archived',
  ARCHIVED_DOCUMENT: 'Archived Document',
  ARCHIVED_DOCUMENTS: 'Archived Documents',
  PREVIEW_DOCUMENT: 'Preview Document',
  PREVIEW_NOT_AVAILABLE: 'Preview is not available for this file. Please download it instead.',
  PREVIEW_FILE_TOO_LARGE: 'This file is too large to preview or render. We recommend downloading it to view it.',
  PREVIEW_ROWS_TRUNCATED: 'Preview limited to the first {shown} of {total} rows.',
  PREVIEW_COLUMNS_TRUNCATED: 'Preview limited to the first {shown} of {total} columns.',
  PREVIEW_SHEETS_TRUNCATED: '{omitted} more worksheet(s) are in the downloaded file.',
  PREVIEW_DOWNLOAD_COMPLETE_FILE: 'Download the file to view everything.',
  PREVIEW_WORKBOOK_SHEETS: 'Workbook sheets',
  PREVIEW_EMPTY_WORKBOOK: 'This workbook does not contain any worksheets.',
  DOWNLOAD_DOCUMENT: 'Download Document',
  DOCUMENT_UPDATED_SUCCESSFULLY: 'Document updated successfully!',
  //END Michael
  //BEGIN Fco
  FILE_SIZE: 'File Size',
  DOWNLOAD_URL: 'Download URL',
  DRAG_AND_DROP: 'Drag & drop some files here, or click to select files.',
  DROP_HERE: 'Drop the files here!',
  UPLOAD_FILES: 'Upload Files',
  UPLOAD_WARNING: 'Do not close the screen while the files are being uploaded.',
  //END Fco
  //BEGIN Fabian
  DRAG_AND_DROP_SINGLE: 'Drag & drop a file here, or click to select a file.',
  //END Fabian
  CSV_IMPORT: {
    IMPORT_INVOICES: 'Import Invoices',
    ONLY_CSV_ALLOWED: 'Only CSV files are allowed.',
    SUBMISSION_INVOICE_CSV_IMPORT_SUCCESS:
      'Invoices have been added correctly.',
    INDICATION_TO_DOWNLOAD_TEMPLATE:
      'In the following link you will find a template for the format of the document to be uploaded. ',
    DOWNLOAD_CSV_TEMPLATE: 'Download CSV template',
    ONLY_ONE_CSV_ALERT: 'Only one file is allowed and it must be a .csv file.',
    ERROR_REPORT_CONFIRMATION:
      'There were errors processing the CSV file, no new invoices were created. To see the error report, download the attached file.',
  },

  //BEGIN Patricio
  EDIT_DOCUMENT: 'Edit Document',
  INFO_MAX_FILE_SIZE: "Attachments can't exceed {limit} total.",
  ERROR_FILE_SIZE_EXCEEDED_TITLE: 'Attachments size limit exceeded',
  ERROR_FILE_SIZE_EXCEEDED: 'This upload would exceed the {limit} limit. Please remove or compress a file and try again.',
  ERROR_FILE_SIZE_EXCEEDED_WITH_NOA:
    'This upload would exceed the {limit} limit. The total includes the NOA document ({noaSize}), which is added automatically. Please remove or compress a file and try again.',
  ONLY_PDF_FILES: 'Only PDF files.',
  //END Patricio
  // START FC2-4178
  INVOICE_DOCUMENTS_SIZE_TOOLTIP: 'Invoice documents: {size}',
  NOA_DOCUMENT_SIZE_TOOLTIP: 'NOA document: {size}',
  // END FC2-4178
}

export const documentsEs: typeof documentsEn = {
  //BEGIN Michael
  DOCUMENT: 'Documento',
  DOCUMENTS: 'Documentos',
  DOCUMENT_TYPE: 'Tipo de Documento',
  OTHER: 'Otro',
  EXPIRATION_DATE: 'Fecha de Expiración',
  INFO_ALL_DOCS_SAME:
    'Todos los archivos serán subidos con el mismo Tipo de Documento y Fecha de Expiración.',
  OTHER_FUNCTION_LINKED:
    'Este tipo de documento está vinculado a otras funciones.',
  ONLY_PDF: 'Solo se permiten archivos PDF.',
  DOCUMENT_TYPE_NOT_ALLOWED: 'Tipo de archivo no permitido. Permitidos: PDF, imágenes y Excel.',
  NOA_WARNING:
    'Un Cliente solo puede tener un documento NOA activo a la vez. Si subes un nuevo documento NOA, los anteriores serán desactivados. Si subes más de un documento con el Tipo NOA, solo el último documento se mantendrá activo.',
  ARCHIVED: 'Archivado',
  ARCHIVED_DOCUMENT: 'Documento Archivado',
  ARCHIVED_DOCUMENTS: 'Documentos Archivados',
  PREVIEW_DOCUMENT: 'Vista Previa del Documento',
  PREVIEW_NOT_AVAILABLE: 'La vista previa no está disponible para este archivo. Descárgalo para verlo.',
  PREVIEW_FILE_TOO_LARGE: 'El archivo es muy grande para mostrarlo o renderizarlo. Te recomendamos descargarlo para visualizarlo.',
  PREVIEW_ROWS_TRUNCATED: 'Vista previa limitada a las primeras {shown} de {total} filas.',
  PREVIEW_COLUMNS_TRUNCATED: 'Vista previa limitada a las primeras {shown} de {total} columnas.',
  PREVIEW_SHEETS_TRUNCATED: 'Hay {omitted} hoja(s) más en el archivo descargado.',
  PREVIEW_DOWNLOAD_COMPLETE_FILE: 'Descargá el archivo para ver todo.',
  PREVIEW_WORKBOOK_SHEETS: 'Hojas del libro',
  PREVIEW_EMPTY_WORKBOOK: 'Este libro no contiene hojas.',
  DOWNLOAD_DOCUMENT: 'Descargar Documento',
  DOCUMENT_UPDATED_SUCCESSFULLY: '¡Documento actualizado exitosamente!',
  //END Michael
  //BEGIN Fco
  FILE_SIZE: 'Tamaño de Archivo',
  DOWNLOAD_URL: 'URL de Descarga',
  DRAG_AND_DROP:
    'Arrastra uno o más archivos aquí, o haz click para seleccionar archivos.',
  DROP_HERE: '¡Suelta los archivos aquí!',
  UPLOAD_FILES: 'Subir Archivos',
  UPLOAD_WARNING:
    'No cierres esta ventana mientras los archivos se están subiendo.',
  //END Fco
  //BEGIN Fabian
  DRAG_AND_DROP_SINGLE:
    'Arrastra un archivo aquí, o haz click para seleccionar un archivo.',
  //END Fabian
  CSV_IMPORT: {
    IMPORT_INVOICES: 'Importar Facturas',
    ONLY_CSV_ALLOWED: 'Solo se permiten archivos CSV.',
    SUBMISSION_INVOICE_CSV_IMPORT_SUCCESS:
      'Las facturas se han agregado correctamente.',
    INDICATION_TO_DOWNLOAD_TEMPLATE:
      'En el siguiente enlace encontrará una plantilla para el formato del documento que debe cargar. ',
    DOWNLOAD_CSV_TEMPLATE: 'Descargar plantilla CSV',
    ONLY_ONE_CSV_ALERT:
      'Solo se permite un archivo y debe ser un archivo .csv.',
    ERROR_REPORT_CONFIRMATION:
      'Hubieron errores al procesar el archivo CSV, no se crearon facturas nuevas. Parar ver el reporte de errores, descargue el archivo adjunto.',
  },
  //BEGIN Patricio
  EDIT_DOCUMENT: 'Editar Documento',
  INFO_MAX_FILE_SIZE: 'Los archivos adjuntos no pueden exceder {limit} en total.',
  ERROR_FILE_SIZE_EXCEEDED_TITLE: 'Tamaño de adjuntos excedido',
  ERROR_FILE_SIZE_EXCEEDED: 'Esta carga superaría el límite de {limit}. Elimina o comprime un archivo e inténtalo de nuevo.',
  ERROR_FILE_SIZE_EXCEEDED_WITH_NOA:
    'Esta carga superaría el límite de {limit}. El total incluye el documento NOA ({noaSize}), que se agrega automáticamente. Elimina o comprime un archivo e inténtalo de nuevo.',
  ONLY_PDF_FILES: 'Solo archivos PDF.',

  //END Patricio
  // START FC2-4178
  INVOICE_DOCUMENTS_SIZE_TOOLTIP: 'Documentos del invoice: {size}',
  NOA_DOCUMENT_SIZE_TOOLTIP: 'Documento NOA: {size}',
  // END FC2-4178
}
